module.exports = {"sys_info":"Informació Sistema","name":"Nom","type_invoice":"Tipus Factura","app_info":"Informació Aplicació","app_version":"Versió de l'Aplicació","system_energetic_control":"Systema Control Energetic"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/InfoApp.json
// module id = 589
// module chunks = 1